import pluralize from 'pluralize'
import { ReactNode, SetStateAction, Dispatch } from 'react'
import { Row, Tag } from 'antd'
import { salesOrderLines_salesOrderLines_items_quoteModelRevision_dfmReports as DfmReportsType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrderLines'
import DataTableFileName from '@Orders/OrderDetailsPage/Status/DataTableFileName'
import { ToggleModalForPartViewerFuncType } from '@Orders/OrderDetailsPage/Status/OrderedItems/components/SalesOrderLinesTable/logic'
import { OrderedItemsRecordType } from '@Orders/OrderDetailsPage/Status/OrderedItems/components/types'

import Box from '~/core/Box'
import Link from '~/core/Link'
import getColor from '~/lib/getColor'
import { useGetOboDetails } from '~/apps/consumer/pages/Quotes/Admin/AdminQuotingPage/components/PartDFMReportPanel/logic'

interface PartsAndSamplesTypes {
    isImOrder: boolean
    record: OrderedItemsRecordType
    isEnabledForIm?: boolean
    orderName: string
    placement: string
    getDescriptionData: (
        processName: string,
        record: OrderedItemsRecordType,
    ) => ReactNode
    toggleModalForPartViewer: ToggleModalForPartViewerFuncType
    setSelectedTab?: Dispatch<SetStateAction<string>>
}

const PartsAndSamples = (props: PartsAndSamplesTypes) => {
    const {
        isImOrder,
        record: {
            revision,
            twoDdrawing,
            processes,
            dfmReports,
            qmrId,
            erpMoldId,
            quote,
        },
        placement,
        isEnabledForIm,
        orderName,
        getDescriptionData,
        toggleModalForPartViewer,
        setSelectedTab,
    } = props

    const isOrderedStatusTable = true
    const { isObo } = useGetOboDetails(quote?.user.id || '')

    const onSeeDFMReportLinkClick = (evt: Event) => {
        evt.preventDefault()
        if (qmrId) {
            evt.stopPropagation()
            toggleModalForPartViewer(true, props.record, null, true)
        }
    }

    const dfmReportsCount =
        dfmReports?.filter((report: DfmReportsType) => report.isPublished)
            ?.length || 0
    const hasDfmReports = Boolean(dfmReportsCount) && isEnabledForIm
    const hasUnpublishedReports = dfmReportsCount !== dfmReports?.length
    const showUnReleasedDfmTag =
        isObo && hasUnpublishedReports && isOrderedStatusTable

    return (
        <>
            <DataTableFileName
                revision={revision}
                twoDdrawing={twoDdrawing}
                processes={processes}
                isOrderedStatusTable
                isImOrder={isImOrder}
                isEnabledForIm={isEnabledForIm}
                qmrId={qmrId}
                orderName={orderName}
                showMoldTag={true}
                erpMoldId={erpMoldId}
                isOrderDetailPage={true}
                quoteUserId={quote?.user.id}
                setSelectedTab={setSelectedTab}
            />
            <Row style={{ margin: '10px 0' }}>
                {getDescriptionData('', props.record)}
            </Row>
            <Row justify="space-between">
                {hasDfmReports && (
                    <Box marginTop="4px">
                        <Link
                            placement={placement}
                            data-test-target={`view-${placement}-dfm-report`}
                            name={`view-${placement}-dfm-report`}
                            style={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: getColor('warning'),
                            }}
                            underlined
                            onClick={onSeeDFMReportLinkClick}
                        >
                            View DFM report {pluralize('file', dfmReportsCount)}
                        </Link>
                    </Box>
                )}
                {showUnReleasedDfmTag && (
                    <Box marginTop="4px">
                        <Tag
                            color="orange"
                            style={{
                                fontSize: '12px',
                                fontWeight: 400,
                            }}
                        >
                            Unreleased DFM
                        </Tag>
                    </Box>
                )}
            </Row>
        </>
    )
}

export default PartsAndSamples
